import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Company } from "@shared/models/company";
import { RegionData } from "@shared/models/region-data";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class CompanyService {
    private baseUrl = `${environment.exploreURL}/api`;
    constructor(private http: HttpClient) { }
    
    getCompanies(): Observable<Company[]> {
         return this.http.get<Company[]>(`${this.baseUrl}/Companies/with-users`);
    }
    createCompany(company: Company): Observable<RegionData> {
        return this.http.post<RegionData>(`${this.baseUrl}/Companies`,company);
    }
    updateCompany(company: Company): Observable<RegionData> {
        return this.http.put<RegionData>(`${this.baseUrl}/Companies`,company);
    }
    deleteCompany(companyId: number): Observable<any> {
        return this.http.delete<RegionData>(`${this.baseUrl}/Companies/${companyId}`);
      }
}
